import { render, staticRenderFns } from "./AppSuccessMessage.vue?vue&type=template&id=76971e50"
import script from "./AppSuccessMessage.vue?vue&type=script&lang=js"
export * from "./AppSuccessMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports